<footer class="footer is-size-7">
  <div class="container">
    <div class="columns">
      <div class="column">
        <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc">
        <p *ngIf="brandService.domain != 'freerateupdate.com'">by freerateupdate.com</p>
      </div>

      <div class="column">
        <p class="is-size-4 is-size-5-mobile" *ngIf="officeStatus && officeStatus.answer">
          <a class="has-text-grey-dark" href="tel:{{ officeStatus.phone }}" target="_blank">
            Call {{ officeStatus.phonefancy }}
          </a>
        </p>
        <p>
          2 Ponds Edge Drive
          <br>
          Chadds Ford, PA 19317
        </p>
        <p>
          <span>
            NMLS #1154338. Go here for the FreeRateUpdate
            <a href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1154338" target="_blank">NMLS Consumer Access Page.</a>
          </span>
        </p>
      </div>

      <div class="column">
        <p>
          <a href="http://latimesblogs.latimes.com/money_co/2010/03/mortgage-rates-remain-near-record-lows-for-modern-era.html" rel="nofollow"
           target="_blank">
            as seen on...
            <br>
            <img src="https://www.freerateupdate.com/images/logo-la-times.png" alt="Los Angeles Times">
          </a>
        </p>
        <p>
          <a href="/contact" target="_blank">Contact Us</a> |
          <a href="/privacy" rel="nofollow" target="_blank">Privacy Policy</a> |
          <a href="/glba" rel="nofollow" target="_blank">GLBA Policy</a> |
          <a href="/cpra_policy" rel="nofollow" target="_blank">CPRA Policy</a>
        </p>
        <p>
          <a href="/terms" rel="nofollow" target="_blank">General Terms</a> |
          <a href="/licensing_disclosure" rel="nofollow" target="_blank">Licensing Disclosure</a> |
          <a href="/landing/approved_lenders.php" target="_blank">Approved Lenders</a> |
          <a href="/html-sitemap" target="_blank">Sitemap</a>
        </p>

        <p>
          <a class="not-sell" href="/your_privacy_choices">Privacy Preferences</a>
        </p>
      </div>
    </div>

    <p>
      Freerateupdate.com is a Marketing Lead Generator, as defined in the General Terms, and is compensated by Lenders for the services provided.
      FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. &copy; FreeRateUpdate.com LLC 2008 - {{ currentYear }}.
      All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.
    </p>
  </div>
</footer>
